import gql from "graphql-tag";
import { userProfileShortFragment } from "@/graphql/user/userProfileFragments";

export const historyFragment = gql`
    fragment historyFragment on History {
        id
        created_at
        updated_at
        created_by {
            ...userProfileShortFragment
        }
        subject
        class
        message
        read
    }
    ${userProfileShortFragment}
`